var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "floating-actions" },
    [
      _vm.app.user.admin || this.$props.export === "true"
        ? _c(
            "button",
            {
              staticClass:
                "floating-button floating-button-small export-button",
              attrs: {
                "data-tip": _vm.t("app-table-export"),
                "aria-label": _vm.t("app-table-export"),
                type: "button",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("download")
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "enable-background": "new 0 0 24 24",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      width: "24px",
                    },
                  },
                  [
                    _c("g", [
                      _c("rect", {
                        attrs: { fill: "none", height: "24", width: "24" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M12,4c4.41,0,8,3.59,8,8s-3.59,8-8,8s-8-3.59-8-8S7.59,4,12,4 M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10 c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2L12,2z M13,12l0-3c0-0.55-0.45-1-1-1h0c-0.55,0-1,0.45-1,1l0,3H9.21 c-0.45,0-0.67,0.54-0.35,0.85l2.79,2.79c0.2,0.2,0.51,0.2,0.71,0l2.79-2.79c0.31-0.31,0.09-0.85-0.35-0.85H13z",
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.to
        ? _c("router-link", { attrs: { to: _vm.to } }, [
            _c(
              "button",
              {
                staticClass: "floating-button",
                attrs: {
                  "data-tip": _vm.label,
                  "aria-label": _vm.label,
                  type: "button",
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "24px",
                        viewBox: "0 0 24 24",
                        width: "24px",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: "M0 0h24v24H0V0z", fill: "none" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }